import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Sessions from "./pages/Sessions";
import Projects from "./pages/Projects";
import Bids from "./pages/Bids";
import Configuration from "./pages/Configuration";
import Logs from "./pages/Logs";
import Analytics from "./pages/Analytics";
import Diagnostics from "./pages/Diagnostics";
import Login from "./pages/Login";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 🔹 Always check sessionStorage at mount
  useEffect(() => {
    if (sessionStorage.getItem("auth") === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  // 🔹 Always subscribe to takeover events
  useEffect(() => {
    const evtSource = new EventSource(
      `${process.env.REACT_APP_API_URL}/events`
    );

    evtSource.onmessage = (event) => {
      if (event.data === "TAKEOVER") {
        alert("Another user has taken over. You have been logged out.");
        localStorage.removeItem("user");
        sessionStorage.removeItem("auth");
        setIsAuthenticated(false);
      }
    };

    return () => evtSource.close();
  }, []);

  // 🔹 Conditionally render AFTER hooks
  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} />;
  }

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/bids" element={<Bids />} />
          <Route path="/configuration" element={<Configuration />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/diagnostics" element={<Diagnostics />} />
          <Route path="/analytics" element={<Analytics />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
